module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-auto-gris.4bdbd1b3.svg";